import LegalDocument from '../components/LegalDocument';
import { PRIVACY } from '../content/legal';

/**
 * The Privacy Policy, at /privacy.
 *
 * Same shape as Terms, for the same reason -- see pages/Terms.tsx. The wording is
 * Sidney's and lives in content/legal.ts.
 */
export default function Privacy() {
  return <LegalDocument document={PRIVACY} />;
}
